<template>
  <component :is="type">
    <h2 v-if="label" class="dea-list-catalog__label">{{ label }}</h2>
    <ul class="dea-list-catalog__main-list">
      <li v-for="(link, i) in links" :key="i" :class="activeClasses(link)" @click="link.active = !link.active">
        <h3 class="dea-list-catalog__section-title">
          <a v-if="link.url" :href="link.url">{{ link.name }}</a>
          <a v-else-if="link.action" href="javascript:void(0);" @click.stop="link.action(link)">{{ link.name }}</a>
        </h3>
      </li>
    </ul>
  </component>
</template>

<script>
export default {
  name: "SidebarLinkList",

  props: {
    label: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "aside",
    },
  },
  computed: {
    links() {
      return this.items;
    },
  },
  methods: {
    activeClasses(link) {
      if (link.active && link.colorMod) {
        return `dea-list-catalog__main-list-item--active ${link.colorMod}`;
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths
</style>
